export default __webpack_public_path__ + "static/media/cricketImage.737560a8.png";